export default __webpack_public_path__ + "static/media/slidermobile1.b221075b.jpg";